import { AxiosError } from "axios";
import { axiosApi } from "./api";
import { NonSquarePixelException, UploadFailedExpection } from "./exceptions";

declare const Resumable: any;
declare const Zakeke: any;
declare const MPlaza: any;

interface ImageTaskResponse {
    state: number
    images?: any[],
    previewUrls?: string[]
}
interface ImageTaskOptions {
    convertEpsToSvg: boolean;
    convertPdfToSvg: boolean;
    convertAiToSvg: boolean;
    IsPdfWithRasterAllowed: boolean;

}
const defaultImageTaskOptions: ImageTaskOptions = {
    convertEpsToSvg: false,
    convertPdfToSvg: false,
    convertAiToSvg: false,
    IsPdfWithRasterAllowed: false,
}
export default class ImageUploadTask {

    constructor(public culture: string, public token: string, public options: ImageTaskOptions = defaultImageTaskOptions) {

    }

    public upload = async (file: File, onProgress?: (progress: number) => void) => {
        return await this.uploadFileChunked(file, file.type, Zakeke.generateUUID(), this.options, onProgress);
    }

    public addPrintingOptions = (printingOptions: MPlaza.PrintTypes | undefined) => {
        const options = this.options;
        if (!printingOptions) return;
        for (let printingOption of printingOptions.toArray()) {
            this.options.convertEpsToSvg = !(printingOption.get('convertEpsToSvg') === false);
            this.options.convertPdfToSvg = !(printingOption.get('convertPdfToSvg') === false);
            this.options.convertAiToSvg = !(printingOption.get('convertAiToSvg') === false);
            this.options.IsPdfWithRasterAllowed = !(printingOption.get('isPdfWithRasterAllowed') === false);
        }
        this.options = options;
    }

    private uploadFileChunked = async (
        imageFile: File,
        mimeType: string,
        fileID: string,
        options: any,
        progressCallaback?: (percentage: number) => void
    ) => {

        let status = await this.resumableUpload(imageFile, mimeType, fileID, progressCallaback);


        if (status === 'OK') {
            let taskID = await this.createImageTask(fileID, options);

            if (taskID !== -1) {
                let responseTaskImage = await this.getImageFromTask(taskID)

                if (options.IsPreview) {
                    if (responseTaskImage)
                        return responseTaskImage.previewUrls;
                }
                else {
                    if (responseTaskImage && responseTaskImage.images) {
                        return responseTaskImage.images;
                    }
                }

            } else {
                throw new UploadFailedExpection();
            }
        }


        return null;
    }

    private resumableUpload = async (imageFile: File, mimeType: string, fileID: string, progressCallback?: (percentage: number) => void) => {

        return new Promise((resolve, reject) => {

            var headersRequest = {
                'Authorization': 'Bearer ' + this.token,
                "Accept-Language": this.culture
            };

            let r = new Resumable({
                target: Zakeke.config.baseImagesUploadApiUrl + "filechunks/upload",
                generateUniqueIdentifier: function () {
                    return fileID;
                },
                maxFiles: 1,
                testChunks: false,
                headers: headersRequest,
                query: { 'resumableType': mimeType },
                simultaneousUploads: 3
            });

            // Adding file
            r.addFile(imageFile);

            // Event Upload handlers
            r.on('fileError', function (file, message) {
                resolve('KO');
                console.error('fileError', file, message);
            });

            r.on('error', function (message, file) {
                resolve('KO');
                console.error('error', message, file);
            });

            r.on('progress', function () {
                let percentage = (r.progress() * 100);

                if (progressCallback)
                    progressCallback(percentage);

            });

            r.on('fileAdded', function (file, event) {
                r.upload();
            });

            r.on('complete', function () {
                resolve('OK');
            });
        });
    }

    private createImageTask = async (fileID: string, options: any) => {

        let imageTask = { 'fileID': fileID, 'options': options };
        let response = await axiosApi.post(Zakeke.config.baseImagesUploadApiUrl + "imagetasks", imageTask);
        return (response) ? response.data.taskID : - 1;
    }

    private getImageFromTask = async (taskID: string): Promise<ImageTaskResponse | null> => {

        let times = 0;

        for (; ;) {
            try {
                let response = await axiosApi.get<ImageTaskResponse>(Zakeke.config.baseImagesUploadApiUrl + "imagetasks/results/" + taskID);

                if (response && response.data.state === 2) {
                    return response.data;
                }
                else if (response && response.data.state === 3) {
                    return null;
                }
            } catch (ex) {
                if ((ex as any).response?.status == 406) throw new NonSquarePixelException();
				else return null;
            }

            times++;
            if (times > 100) {
                return null;
            }

            // Delay 1s
            await new Promise(resolve => setTimeout(resolve, 1000));
        }

    }
}